import React from 'react';
import { EntityProvider, useEntityContext } from './context';
import { Link } from 'react-router-dom';

import Markdown from '../../sharedComponents/Markdown';
import StandardPage from '../../sharedComponents/StandardPage';
import { Avatar } from '@mui/material';
import EntityHeader from './EntityHeader';

import './index.scss';

function ViewEntity() {
  return (
    <EntityProvider>
      <EntityView />
    </EntityProvider>
  );
}

function EntityView() {
  const {
    currentEntity,
    entityTypes,
    userData,
    edgesAsNodeAGrouped,
    edgesAsNodeBGrouped,
  } = useEntityContext();

  if (!currentEntity) {
    return <div>Loading...</div>;
  }

  return (
    <StandardPage className="view-entity-page">
      <EntityHeader />

      { Object.keys(entityTypes).includes('post') && (
        <>
          <h2 className="post-title">{ currentEntity.propertiesByName.title.value }</h2>
          <div className="post-body">
            <Markdown>
              { currentEntity.propertiesByName.mainContent.value }
            </Markdown>
          </div>
        </>
      ) }

      { !Object.keys(entityTypes).includes('post') && (
        <>
          <h3>Properties</h3>
          { currentEntity.properties.map(property => {
            return (
              <div key={property.name} className="property">
                <div className="property-name">{ property.name }</div>
                <div className="property-value">
                  <Markdown>
                    { property.value }
                  </Markdown>
                </div>
              </div>
            );
          }) }

          {/* edges as node a */}
          { Object.entries(edgesAsNodeAGrouped).map(([edgeType, nodesForEdge]) => {
            return (
              <div>
                <div>{ edgeType }</div>
                { nodesForEdge.map(edge => {
                  return (
                    <div key={edge.id} className="property">
                      <Link to={`/${userData.username}/entity/${edge.nodeBNode.id}`}>
                        <div className="property-name">{ edge.nodeBNode.name }</div>
                      </Link>
                    </div>
                  );
                } )}
              </div>
            );
          }) }

          {/* edges as node a */}
          { Object.entries(edgesAsNodeBGrouped).map(([edgeType, nodesForEdge]) => {
            return (
              <div>
                <div>{ edgeType } <b>{ currentEntity.name }</b>:</div>
                { nodesForEdge.map(edge => {
                  return (
                    <div key={edge.id} className="property">
                      <Link to={`/${userData.username}/entity/${edge.nodeANode.id}`}>
                        <div className="property-name">{ edge.nodeANode.name }</div>
                      </Link>
                    </div>
                  );
                } )}
              </div>
            );
          }) }

        </>
      ) }
    </StandardPage>
  );
}

export default ViewEntity;
